const TRANSLATIONS: Record<string, string> = {
  "usageDataFrom.SERVICE_PROVIDER": "Service Provider",
  "usageDataFrom.MANUAL_SCHEDULE": "Manual Schedule",
  "usageDataFrom.SEMI_AUTOMATED_SCHEDULE": "Semi Automated Schedule",
  "usageDataFrom.TELEMETRY": "Telemetry",
  "usageDataFrom.PLC": "PLC",
  "scheduleViewType.ALL": "All",
  "scheduleViewType.MANUAL": "Manual",
  "scheduleViewType.SEMI_AUTOMATED": "Semi Automated",
  SOLAR_CHARGER: "Solar Charger",
  INVERTER: "Inverter",
  GENERATING: "Active Sites",
  OFFLINE: "Offline Sites",
  FAULT: "Errors",
  PER_UNIT: "Per Unit",
  TOTAL_PRICE: "Total Price",
  PENDING: "Pending",
  ACTIVE: "Active",
  EXPIRED: "Expired",
  "chargingStatus.AVAILABLE": "Available",
  "chargingStatus.PREPARING": "Preparing",
  "chargingStatus.CHARGING": "Charging",
  "chargingStatus.SUSPENDED_EVSE": "Suspended EVSE",
  "chargingStatus.SUSPENDED_EV": "Suspended EV",
  "chargingStatus.FINISHING": "Finishing",
  "chargingStatus.RESERVED": "Reserved",
  "chargingStatus.UNAVAILABLE": "Unavailable",
  "chargingStatus.FAULTED": "Faulted",
  "chargingStatus.OFFLINE": "Offline",
  EV_CHARGER: "EV Charger",
};

export default function translate(key: string, category?: string) {
  let fullKey = `${category}.${key}`;
  if (!category) {
    fullKey = key;
  }

  return TRANSLATIONS[fullKey] || key;
}
